/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.TrendTopicType = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The TrendTopicType model module.
   * @module model/TrendTopicType
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>TrendTopicType</code>.
   * @alias module:model/TrendTopicType
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>TrendTopicType</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrendTopicType} obj Optional instance to populate.
   * @return {module:model/TrendTopicType} The populated <code>TrendTopicType</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Shape')) {
        obj['Shape'] = ApiClient.convertToType(data['Shape'], 'String');
      }
      if (data.hasOwnProperty('ColorHex')) {
        obj['ColorHex'] = ApiClient.convertToType(data['ColorHex'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Shape
   * @default ''
   */
  exports.prototype['Shape'] = '';
  /**
   * @member {String} ColorHex
   * @default ''
   */
  exports.prototype['ColorHex'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


